"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Sidebar/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');

var _types = require('./types');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);





var _user = require('shared/selectors/user');
var _conversation = require('shared/selectors/conversation');
var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);
var _store = require('web/store');
var _useFormsGate = require('web/screens/Forms/useFormsGate');

var _hooks = require('web/services/hooks');
var _ui = require('web/services/ui');
var _Icon = require('./Icon'); var _Icon2 = _interopRequireDefault(_Icon);
var _SettingsIcon = require('./SettingsIcon'); var _SettingsIcon2 = _interopRequireDefault(_SettingsIcon);
var _Desktop = require('./Desktop'); var _Desktop2 = _interopRequireDefault(_Desktop);
var _sectionMemory = require('./sectionMemory');
var _icons = require('./icons');

const gotoFormsRoot = () => _store.history.push(_routes2.default.FORMS.ROOT)
const FORMS_TAB_ICON = _react2.default.createElement(_icons.FormsIcon, { size: 22, __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}} )






const Sidebar = ({ onSearch, onFeedback }) => {
  const myUserKey = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserKey)
  const hasInboxBadge = _hooks.useAppSelector.call(void 0, _conversation.selectInboxHasAlert)
  const hasVideo = _hooks.useAppSelector.call(void 0, state =>
    _user.selectCurrentUserHasVideoV1Feature.call(void 0, state) ||
    _user.selectCurrentUserHasVideoV2Feature.call(void 0, state))
  const hasSuperConsole = _hooks.useAppSelector.call(void 0, _user.selectAmISuperUser)
  // Forms shows for a picked org with FORMS, or in My Inbox when any of your
  // orgs has it.
  const hasForms = _useFormsGate.useFormsShown.call(void 0, ) === 'on'

  const screenType = _ui.useScreenType.call(void 0, )

  const location = _reactrouterdom.useLocation.call(void 0, )
  const { pathname } = location

  const activeRoute = _react.useMemo.call(void 0, () => _sectionMemory.sectionOf.call(void 0, pathname), [pathname])
  _react.useEffect.call(void 0, () => _sectionMemory.rememberLocation.call(void 0, myUserKey, location), [myUserKey, location])
  // Each section opens where it was left; see sectionMemory.
  const goto = _react.useCallback.call(void 0, 
    (section, gotoRoot) => () => _sectionMemory.openSection.call(void 0, myUserKey, section, activeRoute, gotoRoot),
    [myUserKey, activeRoute],
  )
  const gotoInbox = _react.useMemo.call(void 0, () => goto(_types.RouteName.inbox, _actions2.default.gotoInbox), [goto])
  const gotoDirectory = _react.useMemo.call(void 0, () => goto(_types.RouteName.directory, _actions2.default.gotoDirectory), [goto])
  const gotoCampaigns = _react.useMemo.call(void 0, () => goto(_types.RouteName.broadcast, _actions2.default.gotoCampaigns), [goto])
  const gotoForms = _react.useMemo.call(void 0, () => goto(_types.RouteName.forms, gotoFormsRoot), [goto])
  const gotoVideoRooms = _react.useMemo.call(void 0, () => goto(_types.RouteName.video, _actions2.default.gotoVideoRooms), [goto])
  const gotoSuperConsole = _react.useMemo.call(void 0, () => goto(_types.RouteName.super, _actions2.default.gotoSuperConsole), [goto])

  if (screenType === 'desktop') {
    return (
      _react2.default.createElement(_Desktop2.default, {
        myUserKey: myUserKey,
        activeRoute: activeRoute,
        hasInboxBadge: hasInboxBadge,
        hasVideo: hasVideo,
        hasForms: hasForms,
        hasSuperConsole: hasSuperConsole,
        onFeedback: onFeedback,
        onGotoInbox: gotoInbox,
        onGotoDirectory: gotoDirectory,
        onGotoCampaigns: gotoCampaigns,
        onGotoForms: gotoForms,
        onGotoVideoRooms: gotoVideoRooms,
        onGotoSuperConsole: gotoSuperConsole, __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
      )
    )
  }

  // Below the desktop breakpoint: the tab bar along the bottom.
  return (
    _react2.default.createElement('div', { className: "blm-sidebar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}
      , _react2.default.createElement(_Icon2.default, {
        title: "Search",
        iconName: _types.RouteName.search,
        onClick: onSearch,
        isHighlighted: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}
      )
      , _react2.default.createElement(_Icon2.default, {
        title: "Inbox",
        iconName: _types.RouteName.inbox,
        hasBadge: hasInboxBadge,
        isActive: activeRoute === _types.RouteName.inbox,
        onClick: gotoInbox, __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}
      )
      , _react2.default.createElement(_Icon2.default, {
        title: "Directory",
        iconName: _types.RouteName.directory,
        isActive: activeRoute === _types.RouteName.directory,
        onClick: gotoDirectory, __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}}
      )
      , _react2.default.createElement(_Icon2.default, {
        title: "Campaigns",
        shortTitle: "Campaigns",
        iconName: _types.RouteName.broadcast,
        isActive: activeRoute === _types.RouteName.broadcast,
        onClick: gotoCampaigns, __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}
      )
      ,  hasForms && (
        _react2.default.createElement(_Icon2.default, {
          title: "Forms",
          iconName: _types.RouteName.forms,
          icon: FORMS_TAB_ICON,
          isActive: activeRoute === _types.RouteName.forms,
          onClick: gotoForms, __self: this, __source: {fileName: _jsxFileName, lineNumber: 113}}
        )
      )
      ,  hasVideo && (
        _react2.default.createElement(_Icon2.default, {
          title: "Video Meetings" ,
          shortTitle: "Video",
          iconName: _types.RouteName.video,
          isActive: activeRoute === _types.RouteName.video,
          onClick: gotoVideoRooms, __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}}
        )
      )
      ,  hasSuperConsole && (
        _react2.default.createElement(_Icon2.default, {
          title: "Superuser Console" ,
          shortTitle: "Super",
          iconName: _types.RouteName.super,
          isActive: activeRoute === _types.RouteName.super,
          onClick: gotoSuperConsole, __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}}
        )
      )
      , _react2.default.createElement('div', { className: "blm-sidebar--settings-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 139}}
        , _react2.default.createElement(_Icon2.default, {
          title: "Feedback",
          iconName: _types.RouteName.feedback,
          onClick: onFeedback, __self: this, __source: {fileName: _jsxFileName, lineNumber: 140}}
        )
        , _react2.default.createElement(_SettingsIcon2.default, {
          title: "Settings",
          iconName: _types.RouteName.settings,
          isActive: activeRoute === _types.RouteName.settings,
          onClick: _actions2.default.gotoSettings,
          tooltipPlace: "top", __self: this, __source: {fileName: _jsxFileName, lineNumber: 145}}
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, Sidebar)
